// Typed wrappers for /api/v2/admin/payout-sync/*.
// Note: endpoints are not in generated clients yet, so keep local wire types.
import { adminFetch } from "@/lib/api/admin-fetch";

// Local types until /api/v2/admin/payout-sync is added to openapi.yaml.
export interface PayoutSyncStatus {
  lastSyncAt: string | null;
  lastChangeAt: string | null;
  source: string;
  totalSymbols: number;
  error: string | null;
}
export interface PayoutSyncTrigger {
  synced: boolean;
  changes: number;
  totalSymbols: number;
  source: string;
  skip: boolean;
  skipReason: string;
}

export interface PayoutAssetRow {
  readonly symbol: string;
  readonly percent: number;
  readonly isFallback?: boolean;
}

export interface PayoutAssetsResult {
  readonly assets: readonly PayoutAssetRow[];
  readonly fallbackAssets: readonly PayoutAssetRow[];
  readonly isFallbackSource: boolean;
}

export interface PayoutHistoryChange {
  readonly symbol: string;
  readonly from: number | null;
  readonly to: number;
}

export interface PayoutHistoryEvent {
  readonly id: string | number;
  readonly createdAt: string;
  readonly actorType: string;
  readonly actorEmail: string | null;
  readonly trigger?: string;
  readonly source?: string;
  readonly totalSymbols?: number;
  readonly changes: readonly PayoutHistoryChange[];
}

export interface PayoutHistoryParams {
  readonly page?: number;
  readonly limit?: number;
  readonly offset?: number;
}

export interface PayoutHistoryResult {
  readonly events: readonly PayoutHistoryEvent[];
  readonly total: number;
  readonly page: number;
  readonly totalPages: number;
}

export type PayoutAssetsResponse = PayoutAssetsResult;
export type PayoutHistoryResponse = PayoutHistoryResult;

function payoutHistoryUrl(page: number, limit: number): string {
  const search = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  return `/api/v2/admin/payout-sync/history?${search.toString()}`;
}

function pageFromParams(params: PayoutHistoryParams): number {
  if (params.page !== undefined) return params.page;
  if (params.offset === undefined || params.limit === undefined) return 1;
  return Math.floor(params.offset / params.limit) + 1;
}

export async function fetchPayoutSyncStatus(): Promise<PayoutSyncStatus> {
  return adminFetch<PayoutSyncStatus>("/api/v2/admin/payout-sync/status");
}

export async function triggerPayoutSync(): Promise<PayoutSyncTrigger> {
  return adminFetch<PayoutSyncTrigger>("/api/v2/admin/payout-sync", {
    method: "POST",
  });
}

export async function fetchPayoutAssets(): Promise<PayoutAssetsResponse> {
  return adminFetch<PayoutAssetsResponse>("/api/v2/admin/payout-sync/assets");
}

export async function fetchPayoutHistory(
  page?: number,
  limit?: number,
): Promise<PayoutHistoryResponse>;
export async function fetchPayoutHistory(
  params: PayoutHistoryParams,
): Promise<PayoutHistoryResponse>;
export async function fetchPayoutHistory(
  pageOrParams: number | PayoutHistoryParams = 1,
  limit = 20,
): Promise<PayoutHistoryResponse> {
  const params =
    typeof pageOrParams === "number"
      ? { page: pageOrParams, limit }
      : pageOrParams;
  return adminFetch<PayoutHistoryResponse>(
    payoutHistoryUrl(pageFromParams(params), params.limit ?? limit),
  );
}
